module.exports = __webpack_public_path__ + "static/media/watch.6b4ab915.png";